/**
 * src/lib/csv.ts — in-browser CSV download (W5 web ergonomics).
 *
 * Web-only: assembles a CSV string and triggers a browser download via a Blob + anchor. On native
 * csvSupported() is false (CSV export is a web feature; mobile shows the data on-screen). RFC-4180
 * quoting for cells containing commas/quotes/newlines.
 *
 * NEVER imports @smartbox/* (mobile invariant 1).
 */
import { Platform } from 'react-native';

export type CsvCell = string | number | null | undefined;

export function csvSupported(): boolean {
  return Platform.OS === 'web' && typeof document !== 'undefined' && typeof Blob !== 'undefined';
}

function escapeCell(v: CsvCell): string {
  const s = v === null || v === undefined ? '' : String(v);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function toCsv(rows: CsvCell[][]): string {
  return rows.map((r) => r.map(escapeCell).join(',')).join('\r\n');
}

/** Trigger a browser download of `rows` as `filename`. No-op on native. */
export function downloadCsv(filename: string, rows: CsvCell[][]): void {
  if (!csvSupported()) return;
  const blob = new Blob([toCsv(rows)], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
